import script from "./ReviewPhotoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewPhotoModal.vue?vue&type=script&setup=true&lang=js"

import "./ReviewPhotoModal.vue?vue&type=style&index=0&id=14c3b1e4&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c3b1e4"]])

export default __exports__